import { JsonapiEntity, attribute, entity, meta } from 'jsonapi-transformers';

@entity({ type: 'importances' })
export class Importance extends JsonapiEntity<Importance> {
  @attribute() description: string;
  @attribute({ name: 'is_active' }) isActive: boolean;

  @meta({ name: 'related_list_items' }) relatedListItems?: number;
}
